import React from 'react';

const TermsConditions = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Terms & Conditions
          </h1>
          <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
            Last updated: December 2024
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Agreement to Terms
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                By accessing and using the services of The Eternal Care, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
              </p>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Appointment Policy
              </h2>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Appointments must be scheduled in advance through phone, WhatsApp, or our website
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Cancellations or rescheduling should be done at least 24 hours in advance
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Late arrivals may result in shortened appointment times or rescheduling
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  No-shows may be subject to a cancellation fee
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Payment Terms
              </h2>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Payment is due at the time of service unless prior arrangements have been made
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  We accept cash, credit/debit cards, and digital payments
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Treatment estimates are provided before procedures
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Insurance claims and reimbursements are the patient's responsibility
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Treatment and Medical Care
              </h2>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  All treatments are performed by qualified dental professionals
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Patients must provide accurate medical history and information
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Treatment plans are customized based on individual needs
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Follow-up care instructions must be followed for optimal results
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Patient Responsibilities
              </h2>
              <ul style={{ paddingLeft: '24px', marginBottom: '16px' }}>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Arrive on time for scheduled appointments
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Inform us of any changes in medical conditions or medications
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Follow post-treatment care instructions
                </li>
                <li className="body-regular" style={{ marginBottom: '8px', lineHeight: '1.7' }}>
                  Maintain good oral hygiene as recommended
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Limitation of Liability
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                While we strive for the best possible outcomes, dental treatments carry inherent risks. The Eternal Care is not liable for any complications arising from pre-existing conditions, patient non-compliance with instructions, or unforeseen medical circumstances.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                Changes to Terms
              </h2>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. Continued use of our services constitutes acceptance of modified terms.
              </p>
              <p className="body-regular" style={{ marginBottom: '16px', lineHeight: '1.7' }}>
                For questions regarding these terms, please contact us at theeternalcare@gmail.com or call +91 9256480329.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
